import { useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';
import StepContainer from '../step-container/step-container.component';
import { LevelOfExperience } from '../../../../../../enums/level-of-experience.enum';
import STRING_KEYS from '../../../../../../language/keys';
import LevelOfExperienceContainer
  from '../../../../../../components/level-of-experience-container/level-of-experience-container.component';
import { ANALYTICS_EVENTS } from '../../../../../../consts/analytics';
import TitleWithTooltip from '../../../title-with-tooltip/title-with-tooltip.component';
import { LevelOfExperienceStepProps } from './level-of-experience-step';

const LevelOfExperienceStep = ({ selectedLevelsOfExperience, changeHandler, backButtonClickHandler }: LevelOfExperienceStepProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const [selectedLevelsOfExperienceSet, setSelectedLevelsOfExperience] = useState(new Set<LevelOfExperience>(selectedLevelsOfExperience));

  const isContinueButtonDisabled = useMemo(
    () => isEqual(Array.from(selectedLevelsOfExperienceSet), selectedLevelsOfExperience) || !selectedLevelsOfExperienceSet.size,
    [selectedLevelsOfExperience, selectedLevelsOfExperienceSet],
  );

  const onLevelOfExperienceClick = (levelOfExperience: LevelOfExperience) => {
    const clonedSet = new Set(selectedLevelsOfExperienceSet);
    if (selectedLevelsOfExperienceSet.has(levelOfExperience)) {
      clonedSet.delete(levelOfExperience);
    } else {
      clonedSet.add(levelOfExperience);
    }
    setSelectedLevelsOfExperience(clonedSet);
  };

  const Subtitle = useMemo(() => (
    <Trans
      i18nKey={ STRING_KEYS.MATCH_TUNE.LEVEL_OF_EXPERIENCE.SUBTITLE }
    >
      <TitleWithTooltip tooltipTitle={ translate(STRING_KEYS.ONBOARDING.ONBOARDING_EXPERIENCE_PAGE_TITLE_TOOLTIP) } />
    </Trans>
  ), [translate]);

  return (
    <StepContainer
      title={ translate(STRING_KEYS.MATCH_TUNE.LEVEL_OF_EXPERIENCE.TITLE) }
      subtitle={ Subtitle }
      backButtonHandler={ backButtonClickHandler }
      continueButtonHandler={ () => changeHandler(Array.from(selectedLevelsOfExperienceSet)) }
      isContinueButtonDisabled={ isContinueButtonDisabled }
      eventName={ ANALYTICS_EVENTS.MATCH_TUNE_LEVELS_OF_EXPERIENCE_STEP_VIEWED }
    >
      <LevelOfExperienceContainer
        selectedItems={ selectedLevelsOfExperienceSet }
        clickHandler={ onLevelOfExperienceClick }
      />
    </StepContainer>
  );
};

export default LevelOfExperienceStep;
